import QRCode from "qrcode";
// import funcs from "tools/functions";
//
const styleSeparator =
  "border-top: 1px dashed; margin-top:0.5cm; margin-bottom:0.5cm";
const generateInvoiceHTML = async (
  _sale,
  ctxPrinting,
  sale,
  record,
  htmlTax,
  infoTransferRoom,
  infoTransfer,
  imageLogo,
) => {
  const lines = sale?.lines || _sale["lines."];
  console.log("Array normal:", sale?.lines);

  const entriesArray = Array.from(_sale["lines."].entries());

  const INVOICE_TYPE = {
    P: "SISTEMA POS:",
    1: "FACTURA DE VENTA ELECTRONICA:",
    M: "CORTESIA:",
    undefined: "CORTESIA:",
  };

  const logoDefault =
    "https://res.cloudinary.com/dl4sdiukx/image/upload/v1733183597/swyxqgd45ftno6qvlzui.png";

  const title =
    record.state !== "transferred"
      ? INVOICE_TYPE[sale?.invoice_type]
      : "TRANSFERIDO";
  const number = _sale?.number ?? _sale?.order;

  const typeSystem = `<div>${title} <b style="display: block;">${number}</b></div>`;

  const activity = [];
  // if (record.state !== "transferred" && record.invoice_type !== "M") {
  //   let origins = record["lines."]
  //     .map((item) => (item.origin ? item.origin.id : null))
  //     .filter((id) => id !== null);

  //   if (origins.length > 0) {
  //     const { data } = await proxy.browse("sale_activity.activity", origins, [
  //       "id",
  //       "time_start",
  //       "time_end",
  //     ]);
  //     activity = data;
  //   }
  // }

  const contenidoHTML = `
    <div style="width: 62mm; padding: 0.1cm; font-family: monospace; font-size: 2.8mm">
      <div style="text-align: center; margin-bottom: 0.5cm" >
        <div style="margin-bottom: 0.5cm"><center><img src=${imageLogo || logoDefault} width="60%"> </center></div>
        <div>${ctxPrinting.company}</div>
        <div>${ctxPrinting.shop}</div>
        <div>NIT: ${ctxPrinting.id_number} ${ctxPrinting.regime_tax}</div>
        <div>${ctxPrinting.street}</div>
        <div>${ctxPrinting.city} Telefono: ${ctxPrinting.phone}</div>
      </div>
      ${typeSystem}
      <div>Fecha: ${new Date(_sale.sale_date).toLocaleDateString("es-CO")}</div>
      <div style="${styleSeparator}"></div>
      <div>
        <div>Cliente: ${sale?.party ?? _sale.party.rec_name}</div>
        ${infoTransferRoom ?? ""}
        ${_sale.description ? `<div>Nombre: ${_sale?.description}</div>` : ""}
        <div>ID: ${_sale?.["party."].id_number}</div>
        <div>Direccion: ${sale?.party_address || ""}</div>
        <div>Telefono: ${sale?.party_phone || _sale?.["party."].mobile}</div>
        <div>Forma de Pago: ${sale?.payment_term || "Cortesia"}</div>
        ${_sale?.courtesy ? `<div>Reservado para: ${_sale?.shipment_date || ""}</div>` : ""}

      </div>
      ${await generateInvoiceLinesHTML(_sale, activity, sale, ctxPrinting, lines, entriesArray)} <!-- Pasamos 'activity' a la función de líneas -->
      <div
        style="${styleSeparator}; border-top:1px dashed ; border-bottom:1px dashed; margin-top: 0.5cm;
        margin-bottom: 0.5cm;"
      ></div>
      ${htmlTax || ""}
      ${infoTransfer || ""}
      <div style=" text-align:center">Creado: ${_sale.create_date} </div>
      <div style=" text-align:center">PROVEEDOR DEL SOFTWARE: PRESIK SAS </div>
      <div style="text-align:center">NIT: 900803782-2</div>
      <div style=" text-align:center">SOFTWARE TRYTON - www.presik.com</div>
    </div>
  `;

  return contenidoHTML;
};

function getQrCode(url) {
  return QRCode.toString(url, { type: "svg" });
}
const generateInvoiceLinesHTML = async (
  _sale,
  activity,
  sale,
  ctxPrinting,
  lines,
  entriesArray,
) => {
  let imageQr = "";
  if (sale && sale?.qr_code) {
    imageQr = await getQrCode(sale?.qr_code, 30, 30);
  }

  const taxes = sale?.taxes ?? {};
  let taxesHtml = `<div style="display: flex; justify-content: space-between;">
      <div>Tipo</div>
      <div>Base</div>
      <div>Imp.</div>
    </div>`;

  if (Object.keys(taxes).length > 0) {
    Object.values(taxes).forEach((item) => {
      const { name, base, tax } = item;

      taxesHtml += `
      <div style="display: flex; justify-content: space-between;">
        <div>${name}</div>
        <div>${parseInt(base || 0).toLocaleString("es-CO")}</div>
        <div>${parseInt(tax || 0).toLocaleString("es-CO")}</div>
      </div>
    `;
    });
  } else {
    taxesHtml += `<div style="text-align: center;">No hay impuestos</div>`;
  }

  return `
  <div style="margin-top: 0.3cm; margin-bottom: 0.1cm; display: flex; justify-content: space-between; border-top: 1px dashed; border-bottom: 1px dashed;">
    <div style="width: 60%;"><b>Articulo</b></div>
    <div style="width: 10%; text-align: center;"><b>Cant</b></div>
    <div style="width: 30%; text-align: right;"><b>Subtotal</b></div>
  </div>
  ${lines
    .map((item, index) => {
      let matchingActivity = activity.find((act) => act.id === item.origin?.id);
      let timeStart = matchingActivity
        ? matchingActivity.time_start.slice(0, -3)
        : "";
      const [key, value] = entriesArray[index];

      if (item.parent) {
        return "";
      }

      let discount = item.discount ?? item?.additionals?.[0]?.discount ?? null;
      console.log("discount", discount);

      return `
          <div style="display: flex; justify-content: space-between; margin-bottom: 0.1cm;">
            <div style="width: 60%;">${item?.parent ? "--> " : ""}${item?.name || item?.product?.name} ${
              discount ? "DESC - " + discount * 100 + "%" : ""
            }
              ${timeStart ? `(${timeStart})` : ""}</div>
            <div style="width: 10%; text-align: center;">${item?.quantity}</div>
            <div style="width: 30%; text-align: right;">
  ${
    !_sale.courtesy
      ? Math.round(
          (!item.parent
            ? value.product?.sale_price_w_tax || 0
            : item?.amount_w_tax || 0) *
            (1 - (discount || 0)) *
            (item?.quantity || 1),
        ).toLocaleString("es-CO")
      : 0
  }
</div>
          </div>
        `;
    })
    .join("")}

  <div style="display: flex; justify-content: space-between; margin-top: 0.3cm;">
    <div><b>Subtotal Base:</b></div>
    <div style="text-align: right;">${Math.round(_sale.untaxed_amount || 0).toLocaleString("es-CO")}</div>
  </div>
  <div style="display: flex; justify-content: space-between;">
    <div><b>Impuestos:</b></div>
    <div style="text-align: right;">${Math.round(_sale.tax_amount || 0).toLocaleString("es-CO") || 0}</div>
  </div>
   <div style="display: flex; justify-content: space-between;  ">
    <div><b>Total:</b></div>
    <div style="text-align: right;">
    <div style="border-top: 1px dashed; width: 20mm; margin-bottom: 0.1cm; "></div>
    ${Math.round(_sale.paid_amount) || Math.round(_sale.total_amount) || 0}
    </div>
    </div>

    <!-- Detalle de impuestos y medio de pago (comentado previamente) -->
    <div style="margin-top: 0.3cm; border-top: 1px dashed; border-bottom: 1px dashed; ;">
        <div><b>DETALLES DE IMPUESTOS</b></div>
        <div style="display: flex; flex-direction: column; gap: 0.2cm;">
            ${taxesHtml}
        </div>
      </div>
      <div style="margin-top: 0.3cm; border-top: 1px dashed; border-bottom: 1px dashed; ;">
        <div><b>MEDIOS DE PAGO</b></div>
        <div style="display: flex; flex-direction: column; gap: 0.2cm;">
          ${
            _sale?.payments &&
            _sale.payments
              .map(
                (item) => `
                <div style="display: flex; justify-content: space-between;">
                  <div>${item.name}</div>
                  <div>${item?.voucher || ""}</div>
                  <div>${Math.round(item.amount).toLocaleString("es-CO")}</div>
                </div>
              `,
              )
              .join("")
          }
        </div>
      </div>

          <div style="display: flex; justify-content: space-between; margin-top: 0.3cm">
            <div>No ITEMS:</div>
          <div>${sale?.lines?.filter((line) => line.parent === undefined || line.parent === null)?.length}</div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div>No PEDIDO:</div>
            <div>${_sale.order}</div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div>CAJA No.:</div>
            <div>${ctxPrinting.sale_device}</div>
          </div>
          <div style="display: flex; justify-content: space-between">
          <div>VENDEDOR:</div>
          <div>${sale?.agent}</div>
        </div>
<div
        style="${styleSeparator}; border-top:1px dashed ; border-botton:1px dashed; margin-top: 0.3cm;
        margin-bottom: 0.3cm;"
          ></div>
     ${
       _sale.courtesy
         ? `
      <div style="display: flex; justify-content: space-between;">
        <div><b>Total Complimentary:</b></div>
        <div style="text-align: right;">${_sale.total_discount_amount}</div>
      </div>
    `
         : `
    <div style="margin-top: 0.3cm;">Autorizacion de facturacion ${
      ctxPrinting.authorizations[sale.invoice_type].kind
    } No ${ctxPrinting.authorizations[sale.invoice_type].number} del ${
      ctxPrinting.authorizations[sale.invoice_type].start_date_auth
    } hasta ${
      ctxPrinting.authorizations[sale.invoice_type].end_date_auth
    }, habilita desde ${ctxPrinting.authorizations[sale.invoice_type].prefix}${
      ctxPrinting.authorizations[sale.invoice_type].from_auth
    } a ${ctxPrinting.authorizations[sale.invoice_type].prefix}${
      ctxPrinting.authorizations[sale.invoice_type].to_auth
    }</div>

    <div style= "max-width: 140px; margin: 0px 50;">${imageQr}</div>
    <div style = "width:100%;  word-wrap: break-word; margin-top: 0.2cm;">CUFE:${
      sale?.invoice_type == "1" ? _sale.cufe : ""
    }</div>
    `
     }
  `;
};

export { generateInvoiceHTML };
